export const SUPPORTED_LANGUAGES = [
	"ar",
	"el",
	"pt",
	"de",
	"en",
	"ru",
	"pl",
	"tr",
	"ro",
	"cs",
	"zh",
	"es",
	"da",
	"fr",
	"ja",
	"fi",
	"hu",
	"sv",
	"lt",
	"bg",
	"uk",
	"it",
	"bs",
	"sl",
	"hr",
	"sq",
	"ms",
	"fa",
	"ku",
	"sr",
];

export const SUPPORTED_PORTAL_LANGUAGE = [
	"ar",
	"el",
	"pt",
	"de",
	"en",
	"ru",
	"pl",
	"tr",
	"ro",
	"cs",
	"zh",
	"es",
	"da",
	"fr",
	"ja",
	"fi",
	"hu",
	"sv",
	"lt",
	"bg",
	"uk",
	"it",
	"bs",
	"sl",
	"hr",
	"sq",
	"ms",
	"fa",
	"ku",
	"sr",
];
